import script from "./dailyRechargePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./dailyRechargePopup.vue?vue&type=script&setup=true&lang=ts"

import "./dailyRechargePopup.vue?vue&type=style&index=0&id=5a9a4f72&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9a4f72"]])

export default __exports__